import { H2, H24, P3 } from '@/lib/ui/components/Typography';
import styles from './HowWeWork.module.scss';
import cn from "classnames";
import { useTranslation } from 'next-i18next';
import Image from "next/image";

const howWorkList = [
    {
        title: 'title1',
        description: "text1"

    },
    {
        title: 'title2',
        description: "text2"

    },
    {
        title: 'title3',
        description: "text3"

    },
]

export const HowWeWork = () => {
    const { t } = useTranslation("index", { keyPrefix: "managementPage" });
    return (
        <div className={styles.howWeWork}>
            <div className={cn(styles.howWeWork__wrapper, styles.container)}>
                <H2 as='h1' className={styles.howWeWork__title}>{t('howWeWorkTitle')}</H2>
                <ul className={styles.howWeWork__cardList}>
                    {howWorkList.map((card, index) => 
                        <li key={card.title} className={styles.howWeWork__cardItem}>
                            <div className={styles.howWeWork__cardItem_infoBlock}>
                                <H24 className={styles.howWeWork__cardItem_title}>{t(`howWeWork.${card.title}`)}</H24>
                                <P3>{t(`howWeWork.${card.description}`)}</P3>
                            </div>
                            
                            {index === 0 && (
                                 <Image
                                 className={styles.howWeWork__cardItem_leafLeft}
                                 width={357}
                                 height={593}
                                 src={"/leaves/leafCard-left.webp"}
                                 sizes="100vw"
                                 alt={""}
                             />
                            )}
                            <Image
                                className={styles.howWeWork__cardItem_bg}
                                fill
                                src={"/images/club/bg.webp"}
                                sizes="(min-width: 1640px) 1624px, (min-width: 1420px) 1352px, calc(95vw + 15px)"
                                alt={""}
                            />
                            {index === 2 && (
                                 <Image
                                 className={styles.howWeWork__cardItem_leafRight}
                                 width={268}
                                 height={402}
                                 src={"/leaves/leafCard-right.webp"}
                                 sizes="100vw"
                                 alt={""}
                             />
                            )}
                        </li>
                    )}
                </ul>
            </div>
        </div>
    )
}